module.exports = __webpack_public_path__ + "prod/1.42.2/img/baishi-icon.cfa2ec08.png";